import React from 'react';
import { AppBar, Toolbar, Box, Button } from '@mui/material';
import { Link } from 'react-router-dom'; 
import icon from '../assets/icon.png'
import { colors, theme } from '../utils/theme';

export default function Header({ isLoggedIn = false }: { isLoggedIn?: boolean }) {
  return (
    <AppBar sx={{
      bgcolor: colors.mainColor,
      zIndex: theme.zIndex.drawer + 1
    }}
    >
      <Toolbar>
        <img src={icon} alt='logo' style={{ height: 30, marginRight: 20 }} />
        たのメシ.com 管理システム
        {process.env.REACT_APP_ENVIRONMENT==='LOCAL' && ' - 開発用 -'}
        {process.env.REACT_APP_ENVIRONMENT==='STAGING' && ' - ステージング -'}
        {process.env.REACT_APP_ENVIRONMENT==='NAKANO' && ' - 中野外食様専用ページ -'}
        <Box sx={{ flexGrow: 1 }} />
        {!isLoggedIn && (
          <>
            <Button color="inherit" component={Link} to="/home">ホーム</Button>
            <Button color="inherit" component={Link} to="/policy">事業背景</Button>
            <Button color="inherit" component={Link} to="/login">ログイン</Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};
